module.exports = __webpack_public_path__ + "153f87d91b12bcb1811c705ee95b32fd.pdf";